import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Table, TableCell, TableHead, TableRow, TableBody, Pagination, Box, Stack, TableContainer, Paper, Button, Switch } from '@mui/material';
import deleteIcon from "../assets/icons/delete.svg";
import editIcon from "../assets/icons/edit.svg";
import { ModalApproveNewUser, ModalEditUserStatus } from './modal/ModalUserStatus';
import ModalDeleteUser from './modal/ModalDeleteUser';
import * as api from '../pages/services/api'
import Loader from './Loader';
import { useNavigate } from 'react-router-dom';
import NoData from "../assets/images/noData.svg";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import ModalDeleteUserType from './modal/ModalDelete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const columns = [
  { id: 'titlename', name: 'ยศ' },
  { id: 'name', name: 'ชื่อ - นามสกุล' },
  { id: 'card_id', name: 'เลขบัตรประชาชน' },
  { id: 'gender', name: 'เพศ' },
  { id: 'phone', name: 'เบอร์โทร' },
  { id: 'department_name_short', name: 'สังกัด' },
];

function ManagePerm({ navigate, userType = [], menuList, handleToggle, handleDelete, handleToggleSubMenu }) {
  const [deleteMode, setDeleteMode] = useState(false);
  const [expandedSubMenus, setExpandedSubMenus] = useState({});

  const toggleDeleteMode = () => {
    setDeleteMode(!deleteMode);
  };

  const toggleSubMenu = (menuCode) => {
    setExpandedSubMenus(prevState => ({
      ...prevState,
      [menuCode]: !prevState[menuCode],
    }));
  };

  return (
    <Box sx={{ border: '1px solid #E1E3E9', borderRadius: '4px' }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 1, marginRight: 1, marginBottom: 1 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/addUserType')}
          sx={{ padding: 1, borderRadius: 1.8, margin: 1, minWidth: 160 }}
        >
          <AddIcon />
          <p style={{ fontWeight: 600, margin: 0 }}>เพิ่มสิทธิใหม่</p>
        </Button>
        <Button
          variant="outlined"
          color="primary"
          onClick={toggleDeleteMode}
          sx={{ padding: 1, borderRadius: 1.8, margin: 1, minWidth: 160 }}
        >
          <DeleteIcon />
          <p style={{ fontWeight: 600, margin: 0 }}>ลบสิทธิการใช้งาน</p>
        </Button>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <TableContainer component={Paper} sx={{ maxWidth: window.innerWidth - 360 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: '600', position: 'sticky', left: 0, zIndex: 1, backgroundColor: 'white' }}>#</TableCell>
                <TableCell
                  sx={{
                    position: 'sticky',
                    borderRight: '1px solid rgba(0, 0, 0, 0.12)',
                    fontWeight: '600',
                    left: '42px',
                    zIndex: 1,
                    backgroundColor: 'white',
                  }}
                >
                  เมนูการใช้งาน
                </TableCell>
                {userType.map((user) => (
                  <TableCell align="center" key={user.group_name} sx={{ fontWeight: '600', minWidth: '180px', position: 'relative' }}>
                    {user.group_name}
                    {deleteMode && (
                      <DeleteIcon
                        sx={{ position: 'absolute', cursor: 'pointer', color: '#E06262' }}
                        onClick={() => handleDelete('delete', user.group_code, user.group_name)}
                      />
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {menuList.map((row, index) => (
                <React.Fragment key={row.menu_code}>
                  <TableRow key={`${row.menu_code}`}> 
                    <TableCell
                      sx={{
                        minWidth: '20px',
                        position: 'sticky',
                        left: 0,
                        zIndex: 1,
                        backgroundColor: 'white',
                      }}
                    >
                      {index + 1}
                    </TableCell>
                    <TableCell
                      sx={{
                        minWidth: '180px',
                        borderRight: '1px solid rgba(0, 0, 0, 0.12)',
                        position: 'sticky',
                        left: '42px',
                        zIndex: 1,
                        backgroundColor: 'white',
                      }}
                    >
                      {row.menu_name}
                      {row.sub_menu_list && row.sub_menu_list.length > 0 && (
                    <Button onClick={() => toggleSubMenu(row.menu_code)} sx={{ minWidth: 'auto', padding: 0, marginLeft: 1 }}>
                      {expandedSubMenus[row.menu_code] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Button>
                      )}
                      </TableCell>
                  
                    {userType.map((user, userIndex) => {
                      const role = user.user_type_role?.[index];
                      if (!role) return null

                      return (
                        <TableCell
                          align="center"
                          key={`${row.menu_code}-${user.group_name}`}
                          sx={{ minWidth: '180px' }}
                        >
                          <FormControlLabel
                            control={<IOSSwitch />}
                            checked={role.menu_status === 'Y'}
                            onChange={() =>
                              handleToggle(index, userIndex, row.menu_code, user.group_code)
                            }
                          />
                        </TableCell>
                      );
                    })}

                  </TableRow>
                  {row.sub_menu_list && row.sub_menu_list.length > 0 && expandedSubMenus[row.menu_code] && (
                    row.sub_menu_list.map((subMenu, subIndex) => (
                      <TableRow key={`${row.menu_code}-sub-${subIndex}`}>
                        <TableCell
                          sx={{
                            minWidth: '20px',
                            position: 'sticky',
                            left: 0,
                            zIndex: 1,
                            backgroundColor: 'white',
                          }}
                        />
                        <TableCell
                          sx={{
                            paddingLeft: '30px',
                            fontStyle: 'italic',
                            minWidth: '180px',
                            borderRight: '1px solid rgba(0, 0, 0, 0.12)',
                            position: 'sticky',
                            left: '42px',
                            zIndex: 1,
                            backgroundColor: 'white',
                          }}
                        >
                          {subMenu.sub_menu_name}
                        </TableCell>
                        {userType.map((user, userIndex) => (
                          <TableCell align="center" key={`${row.sub_menu_list[subIndex]}-${user.group_name}`} sx={{ minWidth: '180px', backgroundColor:'#f5f5f5' }}>
                            {user.user_type_role[index].menu_status === 'Y' ? (
                              <FormControlLabel
                                control={<SubMenuSwitch />}
                                checked={
                                  user.user_type_role[index]?.sub_menu_list?.includes(subMenu.sub_menu_number)
                                }
                                onChange={() =>
                                  handleToggleSubMenu(
                                    index,
                                    userIndex,
                                    user.group_code,
                                    row.menu_code,
                                    subMenu.sub_menu_number
                                  )
                                }
                              />
                            ) : null}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))
                  )}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}


function UserTab({ users, activeTab, currentPage,searchQuery, userTypeRole }) {
  const [page, setPage] = useState(currentPage);
  const [totalPage, setTotalPage] = useState(1);
  const itemsPerPage = 10;
  const [paginatedUsers, setPaginatedUsers] = useState([]);
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();
  const [menuList, setMenuList] = useState([]);
  const [userType, setUserType] = useState([]);

  // Modal state and ID tracking
  const [modals, setModals] = useState({
    editStatus: { open: false, userStatus: '', uid: '' },
    approveUser: { open: false, uid:'', fname:'', lname:'' },
    deleteUser: { open: false, uid: '', fname:'', lname:'' },
    delete: {open: false, group_code: '', group_name:''}
  });


  useEffect(() => {
    if (activeTab !== "Permission") {
      const startIndex = (page - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      setPaginatedUsers(users.slice(startIndex, endIndex));
      fetchUserData(1,searchQuery);
    } else {
      fetchMenuList();
      fetchUserType();
    }
  }, [users, page]);


  const fetchUserData = async (page,search) => {
    setLoading(true);
    let status = "N"
    if (activeTab === 'Active User') {
        status = "W"
    } else if (activeTab === 'UnActive User') {
        status = "C"
    }
    // const res = await api.findUser(page,search,status);
    const res = await api.findUserbyType(page,search,status,userTypeRole);
    setLoading(false);
    if (res) {
        if (res['data']['code'] === 200) {
            const detail = res['data']['data'];
            setPaginatedUsers(detail);
            setTotalPage(res['data']['pagging']['totalPage'])
        } else if ("Not found data." === res['data']['message']) {
          setPaginatedUsers([]);
            setTotalPage(1);
        } else {
            //alert(res['data']['message']);
        }
    } else {
      alert("ไม่ตอบสนอง");
    }
};

const fetchMenuList = async () => {
  setLoading(true);
    const res = await api.findMenu("line_number");
    setLoading(false);
    if (res) {
        if (res['data']['code'] === 200) {
            const detail = res['data']['data'];
            setMenuList(detail);
        } else {
            //alert(res['data']['message']);
        }
    } else {
      alert("ไม่ตอบสนอง");
    }
} 

const fetchUserType = async () => {
  setLoading(true);
    const res = await api.findUserType();
    setLoading(false);
    if (res) {
        if (res['data']['code'] === 200) {
            const detail = res['data']['data'];
            setUserType(detail);
        } else {
            //alert(res['data']['message']);
        }
    } else {
      alert("ไม่ตอบสนอง");
    }
} 


  const handlePageChange = (_, value) => {
    fetchUserData(value,searchQuery);
    setPage(value)
  };

  const handleOpenStatusModal = (type, userStatus = '', id='', fname, lname) => {
    setModals((prevModals) => ({
      ...prevModals,
      [type]: type === 'editStatus' ? { open: true, userStatus, id } : { open: true, id, fname, lname },
    }));
  };

  const handleOpenDeleteUserModal = (type, id='', fname, lname) => {
    setModals((prevModals) => ({
      ...prevModals,
      [type]: type === 'deleteUser' ? { open: true, id, fname, lname  } : true,
    }));
  };

  const handleOpenDeleteModal = (type, group_code, group_name) => {
    // console.log(group_code)
    setModals((prevModals) => ({
      ...prevModals,
      [type]: type === 'delete' ? { open: true, group_code, group_name  } : true,
    }));
  };

  const handleCloseModal = (type) => {
    setModals((prevModals) => ({
      ...prevModals,
      [type]: type === 'editStatus' ? { open: false, userStatus: '' } : false,
    }));
  };

  const handleToggle = async (menuIndex, userIndex, menuCode, groupCode) => {
    setUserType((prevUserType) => {
      const newUserType = [...prevUserType];
      const currentStatus = newUserType[userIndex].user_type_role[menuIndex].menu_status;
  
      newUserType[userIndex].user_type_role[menuIndex].menu_status =
        currentStatus === "Y" ? "N" : "Y";
  
      return newUserType; 
    });

    let inform = {
      group_code: groupCode,
      menu_code:menuCode
    }


    setLoading(true);
    let res = await api.updateUserTypeRole(inform);
    setLoading(false);
    if (res) {
      if (res['data']['code'] === 200) {
        // return;
      } else {
          //alert(res['data']['message']);
      }
    } else {
      alert('ไม่ตอบสนอง');
    }
  };

  const handleToggleSubMenu = async (menuIndex, userIndex, groupCode, menuCode, subMenuNumber) => {
    setUserType((prevUserType) => {
      const newUserType = [...prevUserType];
      const currentStatus = newUserType[userIndex]?.user_type_role?.[menuIndex];

      if (currentStatus) {
        if (!Array.isArray(currentStatus.sub_menu_list)) {
          currentStatus.sub_menu_list = [];
        }
  
        if (currentStatus.sub_menu_list.includes(subMenuNumber)) {
          currentStatus.sub_menu_list = currentStatus.sub_menu_list.filter(
            (number) => number !== subMenuNumber
          );
        } else {
          currentStatus.sub_menu_list.push(subMenuNumber);
        }
      }
  
      return newUserType;
    });
  
    let inform = {
      group_code: groupCode,
      menu_code: menuCode,
      sub_menu_number: `${subMenuNumber}`
    };
    

    setLoading(true);
    let res = await api.updateUserTypeRole(inform);
    setLoading(false);
    if (res) {
      if (res['data']['code'] === 200) {
        // return;
      } else {
          //alert(res['data']['message']);
      }
    } else {
      alert('ไม่ตอบสนอง');
    }
  };
  

  return (
    <>
      {/* Modals */}
      {modals.editStatus.open && (
        <ModalEditUserStatus
          onClose={() => handleCloseModal('editStatus')}
          initialStatus={modals.editStatus.userStatus}
          id = {modals.editStatus.id}
        />
      )}
      {modals.approveUser.open && (
        <ModalApproveNewUser
          onClose={() => handleCloseModal('approveUser')}
          uid = {modals.approveUser.id}
          fname = {modals.approveUser.fname}
          lname = {modals.approveUser.lname}
        />
      )}
      {modals.deleteUser.open && (
        <ModalDeleteUser
          onClose={() => handleCloseModal('deleteUser')}
          uid = {modals.deleteUser.id}
          fname={modals.deleteUser.fname}
          lname={modals.deleteUser.lname}
          />
      )}
      {modals.delete.open && (
        <ModalDeleteUserType
        onClose={() => handleCloseModal('delete')}
        group_code = {modals.delete.group_code}
        group_name={modals.delete.group_name}
        />
        )
      }

      {/* Table */}
      <Loader loading={loading} />
      {activeTab !== 'Permission' ?
      <TableContainer
        component={Paper}
        sx={{ height: 668, border: 1, borderColor: '#AEB4DD', borderRadius: '0px 6px 6px 6px', borderTop: 0 }}
      >
        <Table stickyHeader aria-label="user table">
          <TableHead>
            <TableRow>
              <TableCell align="center" sx={{ backgroundColor: '#C8EBEB', fontWeight: 600 }}>สถานะ</TableCell>
              {columns.map((col) => (
                <TableCell key={col.id} align="left" sx={{ backgroundColor: '#C8EBEB', fontWeight: 600 }}>
                  {col.name}
                </TableCell>
              ))}
              {activeTab !== 'UnActive User' && (
                <TableCell align="center" sx={{ backgroundColor: '#C8EBEB', fontWeight: 600 }}>จัดการ</TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedUsers.length > 0 ? (
              paginatedUsers.map((user) => ( 
                <TableRow key={user.uid}>
                  <TableCell sx={{ padding: 1 }}>
                    <Box
                      align="center"
                      onClick={() => handleOpenStatusModal(
                        activeTab !== 'New User' ? 'editStatus' : 'approveUser',
                        activeTab === 'Active User' ? 'active' : 'deactivated',
                        user.uid,
                        user.firstname,
                        user.lastname
                      )}
                      sx={{
                        width: "110px",
                        borderRadius: "12px",
                        padding: '12px',
                        fontWeight: 600,
                        margin: "0 auto",
                        cursor: 'pointer',
                        backgroundColor: activeTab === 'Active User' ? '#478F96' : activeTab === 'New User' ? '#EBC85F' : '#FFC4B6',
                        color: activeTab === 'Active User' ? 'white' : activeTab === 'New User' ? '#5E4F20' : '#1D1B20',
                        "@media (max-width: 800px)": { width: "100px" },
                      }}
                    >
                      {activeTab === 'Active User' ? 'Active' : activeTab === 'New User' ? 'Approve' : 'Deactivated'}
                    </Box>
                  </TableCell>
                  {columns.map((col) => {
                    let value;
                    
                    // Handle the 'name' column separately
                    if (col.id === 'name') {
                      value = `${user.firstname || ''} ${user.lastname || ''}`.trim() || "-";
                    } else {
                      value = (user[col.id] !== null && user[col.id] !== undefined) ? user[col.id] : "-";
                    }

                    return (
                      <TableCell key={col.id} align="left">
                        {value}
                      </TableCell>
                    );
                  })}
                  {activeTab !== 'UnActive User' && (
                    <TableCell align="center">
                      <Box>
                        {activeTab === 'New User' ? (
                          <img
                            src={deleteIcon}
                            alt="delete"
                            style={{ width: "17px", cursor: 'pointer' }}
                            onClick={() => handleOpenDeleteUserModal('deleteUser', user.uid, user.firstname, user.lastname)}
                          />
                        ) : (
                          <>
                            <img
                              src={editIcon}
                              alt="edit"
                              style={{ width: "20px", marginRight: '8px', cursor: 'pointer' }}
                              onClick={() => navigate('/editUser', {state: { cardId: user.card_id}})}
                            />
                            <img
                              src={deleteIcon}
                              alt="delete"
                              style={{ width: "17px", cursor: 'pointer' }}
                              onClick={() => handleOpenDeleteUserModal('deleteUser', user.uid, user.firstname, user.lastname)}
                            />
                          </>
                        )}
                      </Box>
                    </TableCell>
                  )}
                </TableRow>
              ))
            ) : (
              <TableRow>
              <TableCell colSpan={columns.length + (activeTab !== 'UnActive User' ? 2 : 1)} sx={{ height: '610px', padding: 0 }}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  flexDirection="column" // Stacks text and image vertically
                  sx={{ height: '100%', fontSize: '18px', fontWeight: 600, color: '#478F96' }}
                >
                  <div>ไม่มีข้อมูล</div>
                  <img src={NoData} alt="No data" style={{ maxWidth: '100%' }} />
                </Box>
              </TableCell>
            </TableRow>

            )}
          </TableBody>
        </Table>
      </TableContainer>
      :
      <ManagePerm
      navigate = {navigate}
      userType = {userType}
      menuList = {menuList}
      handleToggle = {handleToggle}
      handleDelete = {handleOpenDeleteModal}
      handleToggleSubMenu={handleToggleSubMenu}
      />
        }

        {activeTab !== "Permission" ? 
        <Box sx={{ display: 'flex', justifyContent: 'end', margin: '10px 0' }}>
          <Stack spacing={2}>
            <Pagination
              count={totalPage}
              page={page}
              onChange={handlePageChange}
              shape="rounded"
              color="primary"
            />
          </Stack>
        </Box> :
        <div></div>
        }
    </>
  );
}

// Prop validation
UserTab.propTypes = {
  users: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeTab: PropTypes.string.isRequired,
};

export default UserTab;


const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#478F96',
        opacity: 1,
        border: 0,
        ...theme.applyStyles('dark', {
          backgroundColor: '#2ECA45',
        }),
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
      ...theme.applyStyles('dark', {
        color: theme.palette.grey[600],
      }),
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
      ...theme.applyStyles('dark', {
        opacity: 0.3,
      }),
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
    ...theme.applyStyles('dark', {
      backgroundColor: '#39393D',
    }),
  },
}));

const SubMenuSwitch = styled(IOSSwitch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#88C9BF',
  },
}));